import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Users, Calendar, Crown, Sparkles,
  Receipt, Megaphone, Settings, LogOut,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/clientes", label: "Clientes", icon: Users, testid: "nav-clientes" },
  { to: "/agenda", label: "Agenda", icon: Calendar, testid: "nav-agenda" },
  { to: "/membresias", label: "Membresías", icon: Crown, testid: "nav-membresias" },
  { to: "/servicios", label: "Servicios", icon: Sparkles, testid: "nav-servicios" },
  { to: "/ventas", label: "Ventas", icon: Receipt, testid: "nav-ventas" },
  { to: "/marketing", label: "Marketing", icon: Megaphone, testid: "nav-marketing" },
  { to: "/ajustes", label: "Ajustes", icon: Settings, testid: "nav-ajustes" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const handleLogout = async () => {
    await logout();
    nav("/catalogo");
  };
  return (
    <aside
      data-testid="sidebar"
      className="hidden lg:flex flex-col fixed top-0 left-0 h-screen w-64 z-30"
      style={{ backgroundColor: "#1A1A1A", color: "#FBF6F2" }}
    >
      <div className="px-6 pt-8 pb-6">
        <div
          className="rounded-md px-5 py-5 flex items-center justify-center"
          style={{ backgroundColor: "#FBF6F2" }}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_salon-studio-pro-2/artifacts/7kyv63p4_LOGO%20LAKA%20CLUB%20BEAUTY.webp"
            alt="LAKA Club Beauty"
            data-testid="sidebar-logo"
            className="w-full h-auto max-h-24 object-contain"
          />
        </div>
        <div className="mt-5 text-center">
          <div className="text-[9px] tracking-[0.4em] uppercase" style={{ color: "#D6B36A" }}>
            Business Studio
          </div>
          <div className="mt-1 text-[10px] tracking-[0.25em] uppercase" style={{ color: "#8a8579" }}>
            Panel operativo
          </div>
        </div>
      </div>

      <div className="px-6" style={{ height: 1, background: "linear-gradient(90deg, transparent, #3a3a3a, transparent)" }} />

      <nav className="flex-1 px-4 py-6 space-y-1 overflow-y-auto">
        {NAV.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-md text-sm transition-all duration-300 group ${
                isActive
                  ? "bg-[#242424] text-[#FBF6F2]"
                  : "text-[#B8B0A6] hover:text-[#FBF6F2] hover:bg-[#232323]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  size={18}
                  strokeWidth={1.25}
                  style={{ color: isActive ? "#D6B36A" : undefined }}
                />
                <span className="tracking-wide">{label}</span>
                {isActive && (
                  <span className="ml-auto w-1 h-4 rounded-full" style={{ backgroundColor: "#D6B36A" }} />
                )}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="p-6 border-t" style={{ borderColor: "#2a2a2a" }}>
        <div className="laka-eyebrow" style={{ color: "#8a8579" }}>Sesión</div>
        <div className="mt-1 text-sm text-[#FBF6F2]">{user?.username || "admin"}</div>
        <button
          data-testid="sidebar-logout"
          onClick={handleLogout}
          className="mt-3 w-full inline-flex items-center gap-2 px-3 py-2 rounded-md text-xs tracking-wider text-[#B8B0A6] hover:text-[#FBF6F2] hover:bg-[#232323] transition-colors"
        >
          <LogOut size={14} strokeWidth={1.25} /> Cerrar sesión
        </button>
        <div className="mt-4 laka-eyebrow" style={{ color: "#8a8579" }}>Centro</div>
        <div className="mt-1 text-sm text-[#FBF6F2]">Madrid · Salamanca</div>
        <div className="text-xs text-[#8a8579]">Calle Serrano, 88</div>
      </div>
    </aside>
  );
}
